import style from './Footer.module.css';
import icons from '../../../../img/icons/icons';
import { ButtonTextSimple } from '../../buttons/buttonTextSimple/ButtonTextSimple';
import { useState } from 'react';
import { FormInput } from '../../forms/FormInput';
import { FormInputBox } from '../../forms/FormInputBox';
import { ButtonActionWide } from '../../buttons/actionWide/ButtonActionWide';

import { ContactServices } from '../../../Services/api/contacts/Contacts.services';
import { useToast } from '../../../Contexts/Toast.context';

export const Footer = () => {
    const { showToast } = useToast();

    const [Assunto, setAssunto] = useState('');
    const [Nome, setNome] = useState('');
    const [Descricao, setDescricao] = useState('');
    const [WhatsApp, setWhatsApp] = useState('');
    const [ErrorMessage, setErrorMessage] = useState('');
    
    const handleChangeAssunto = (text: string) => {
        setAssunto(text);
    }
    const handleChangeNome = (text: string) => {
        setNome(text);
    }
    const handleChangeDescricao = (text: string) => {
        setDescricao(text);
    }
    const handleChangeWhatsApp = (text: string) => {
        setWhatsApp(text);
    }

    const click = async () => {
        if (!Nome || !Assunto || !WhatsApp || !Descricao) {
            showToast('Por favor, preencha todos os campos.', 'warning');
            return;
        }

        try {
            const result = await ContactServices.createContact({
                ClientName: Nome,
                Assunto,
                WhatsApp,
                Descricao
            });

            if (result instanceof Error) {
                showToast('Erro ao enviar mensagem. Tente novamente mais tarde.', 'error');
            } else {
                showToast('Mensagem enviada com sucesso!', 'success');
                setAssunto('');
                setNome('');
                setDescricao('');
                setWhatsApp('');
            }
        } catch (error) {
            showToast('Erro inesperado ao enviar mensagem.', 'error');
        }
    }

    return (
        <div className={style.Content}>
            <div className={style.ContentFooter}>
                <div className={style.InstitucionalArea}>
                    <div className={style.FooterTitle}>
                        <span>Institucional</span>
                    </div>
                    <div className={style.InstitucionalButtons}>
                        <ButtonTextSimple text="Cursos" onClick={click} />
                        <ButtonTextSimple text="Sobre" onClick={click} />
                        <ButtonTextSimple text="Trabalhe Conosco" onClick={click} />
                    </div>
                </div>

                <div className={style.LocationArea}>
                    <div className={style.FooterTitle}>
                        <span>Onde Estamos?</span>
                    </div>
                    <div className={style.Location}>
                        <img src={icons.fachada} alt="Fachada NewZape" />
                    </div>
                    <div className={style.AdressText}>
                        <img src={icons.location} alt="Ícone Localização" />
                        <span>
                            Rua Benjamin Constante, Nº 731 - Centro -
                            Palmeira das Missões - RS
                        </span>
                    </div>
                </div>

                <div className={style.ContactArea}>
                    <div className={style.FooterTitle}>
                        <span>Fale Conosco</span>
                    </div>
                    <div className={style.FormArea}>
                        <FormInput placeholder="Assunto" nome="Assunto" change={handleChangeAssunto} value={Assunto} viewName={false} errorMessage="" />
                        <FormInput placeholder="Nome completo" nome="Nome" change={handleChangeNome} value={Nome} viewName={false} errorMessage="" />
                        <FormInput placeholder="WhatsApp" nome="WhatsApp" change={handleChangeWhatsApp} value={WhatsApp} viewName={false} errorMessage="" />
                        <FormInputBox rows={3} placeholder="Como podemos ajudar?" nome="Mensagem" change={handleChangeDescricao} value={Descricao} viewName={false} errorMessage="" />
                        <ButtonActionWide click={click} nome="Enviar Mensagem" />
                    </div>
                </div>
            </div>

            <div className={style.Copyright}>
                <span>© 2024 NewZape Cursos - Todos os direitos reservados.</span>
            </div>
        </div>
    )
}